import styled from 'styled-components';

export const CartPreviewContainer = styled.div`
  background: ${Styles.color.grey.five};
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  width: 25.875rem;
`;
